import styled from 'styled-components'
import { ImgHTMLAttributes } from 'react'
import { Button } from './Button.style';

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    transparent?: boolean;
}

export const Img = styled.img<ImageProps>`
    width: 100%;
    max-width: 100%;
    ${({ transparent }: ImageProps) => transparent && `
            mix-blend-mode: multiply;
    `}
`

interface clickableProps {
    onClick?: any;
}

export const ZommableCmpContainer = styled.div<clickableProps> `
    position: relative;
    min-width: 90px;
    width: 90px;
    min-height: 130px;
    height: 130px;
    border: 4px solid #3079c9;
    cursor: pointer;

    &.LINEAR {
        border: 2px solid #499640;
        border-radius: 8px;
        min-width: 118px;
        width: 118px;
        min-height: 174px;
        height: 174px;

        img {
            margin: 2px 0px;
        }
    }
    

    &.is-loading {
        border: none;
    }

    img {
        width: 100%;
        max-width: 100%;
        height: 100%;
    }

    &.full-page-img {
        border: none;
        cursor: unset;
        position: fixed;
        top: 80px;
        right: 26px;
        height: auto;
        width: calc(100vW - 52px);
        z-index: 99;

        img {
            //width: unset;
            //max-width: unset;
            height: unset;
        }
    }
`

export const ZommableImageContainer = styled.div<clickableProps>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    //height: 100%;
    &.full-page-img {
        overflow: scroll;
        z-index: 99;
        padding: 8px;
        background-color: #fff;
    }
    
`

export const FullPageOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.55);
    z-index: 10;
`

export const ImgZoomBtn = styled(Button)`
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(50%, 50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #3079c9;
    font-size: 16px;
    color: white;
    cursor: pointer;

    &.LINEAR {
        width: 35px;
        height: 35px;
        background-color: white;
        border: 1px solid green;
        border-radius: 50%;
    }
`

export const CloseImgZoomBtn = styled(ImgZoomBtn)`
    width: 40px;
    height: 40px;
    bottom: unset;
    top: 0;
    transform: translate(50%, -50%);
    font-size: 1.2rem;
    z-index: 100;
`
